module.exports = __webpack_public_path__ + "img/success.d515d4c4.png";